<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import identificacionSustanciasAPI from "../../../services/standards/identificacionSustancias/identificacionSustanciasAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title:
      "4.1.3 Identificación de sustancias catalogadas como carcinógenas o con toxicidad aguda",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
  },
  data() {
    return {
      title:
        "4.1.3 Identificación de sustancias catalogadas como carcinógenas o con toxicidad aguda",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Identificación de sustancias",
        },
        {
          text: "Ver",
          active: true,
        },
      ],
      lista: [],
      file: null,
      loading: true,
      acta: null,
      item: null,
      search: "",
      itemData: null,
      identificacion: {
        observations: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(43)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getList() {
      identificacionSustanciasAPI
        .get(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          let identification = response.data.data;
          this.lista = identification;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getIdentificacion() {
      identificacionSustanciasAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.identificacion = {
            observations: response.data.observations,
            file: response.data.file,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getList();
    this.getItemData();
    this.getIdentificacion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-3 px-2 text-center" label="Descargar matriz sustancias químicas"
                    label-for="file">
                    <div class="d-flex justify-content-center">
                      <button :disabled="!allowAccess()" style="
                        background-color: transparent !important;
                        border: none;
                      " type="button" @click="gotoDigitalOcean(`${identificacion.file}`)">
                        <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-4" label="Observaciones" label-for="Observaciones">
                    <b-form-textarea disabled id="description" maxlength="200" v-model="identificacion.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
